import * as React from "react";
import {connect} from "react-redux";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {Option} from "ts-option";
import {RootState} from "../../../store/reducer/root/RootState";
import IndividualContact from "../../../model/contact/IndividualContact";
import {getIndividualContact} from "../../../store/view/contact";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import DropDownList, {DropDownItem} from "../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import SearchDropDown from "../../../hiberUiKit/src/molecules/SearchDropDown/SearchDropDown";
import {Dispatch} from "redux";
import Toast from "../../helper/Toast";
import TextUtils from "../../../utils/TextUtils";
import EditIndividualContactModal from "../../contacts/modal/EditIndividualContactModal";
import CreateContactModal from "../../contacts/modal/CreateContactModal";
import MessageModal from "./MessageModal";
import TwilioModal from "./TwilioModal";
import Job from "../../../model/job/Job";
import {addCallEvent, editJob, sendEmailToJobContact, sendSmsToJobContact} from "../../../store/action/job/job";
import AddEventModal from "./AddEventModal";
import EmailMessageModal from "./EmailMessageModal";
import * as _ from "underscore";
import {fetchIndividualContacts} from "../../../store/action/contacts/contacts";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";

interface ComponentProps {
	/**
	 * Job.
	 */
	job: Option<Job>
}

interface ReduxProps {
	/**
	 * Job prospect.
	 */
	contact: Option<IndividualContact>
	/**
	 * Organisation individual contacts.
	 */
	individualContacts: IndividualContact[],
	/**
	 * Indicates if all contacts are fetched
	 */
	allContactsFetched: boolean
}

interface DispatchProps {
	/**
	 * Edit job action.
	 * @param {Job} job
	 */
	editJob: (job: Job) => void;
	/**
	 * Send sms to job contact action.
	 * @param {Job} job
	 */
	sendSmsToJobContact: (jobId: string, message: string) => void;
	/**
	 * Send e-mail to lead contact action.
	 * @param {string} jobId
	 * @param {string} subject
	 * @param {string} message
	 */
	sendEmailToJobContact: (jobId: string, subject: string, message: string) => void;
	/**
	 * Add phone call event
	 * @param {string} jobId
	 * @param {string} eventMessage
	 */
	addCallEvent: (jobId: string, eventMessage: string) => void;
	/**
	 * Fetch all individual contacts
	 */
	fetchContacts: () => void;
}

interface IState {
	/**
	 * Menu dropdown visibility.
	 */
	menuDropDownVisible: boolean
	/**
	 * Search dropdown visibility.
	 */
	searchBoxVisible: boolean
	/**
	 * New contact modal form visibility.
	 */
	newContactVisible: boolean
	/**
	 * Edit contact modal form visibility.
	 */
	editContactVisible: boolean
	/**
	 * Send sms to contact modal visibility.
	 */
	sendSmsModalVisible: boolean;
	/**
	 * Send e-mail to contact modal visibility.
	 */
	sendEmailModalVisible: boolean;
	twilioModal: boolean;
	/**
	 * Add event modal visibility.
	 */
	addEventModal: boolean;
}

type Props = ComponentProps & ReduxProps & DispatchProps

class JobContact extends React.PureComponent<Props, IState> {

	selectedContactMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
		{id: "l2", label: "Create new"},
		{id: "l3", label: "Edit"},
		{id: "l4", label: "Send SMS", disabled: !this.props.contact.map(c => c.isOneOfPhoneNumbersMobile()).getOrElse(false)},
		{
			id: "l5",
			label: "Send e-mail",
			disabled: this.props.contact.map(c => c.data.communication.emails.getOrElse([]).length == 0).getOrElse(true)
		},
		{id: "l6", label: "Copy"},
		{
			id: "l7",
			label: "Call",
			disabled: this.props.contact.map(c =>
				c.data.communication.phoneNumbers.getOrElse([]).length == 0
			).getOrElse(true)
		},
		{id: "l8", label: "Add phone call event"}
	];

	emptyContactMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
		{id: "l2", label: "Create new"}
	];

	constructor(props: Props) {
		super(props);
		this.state = {
			menuDropDownVisible: false,
			searchBoxVisible: false,
			newContactVisible: false,
			editContactVisible: false,
			sendSmsModalVisible: false,
			sendEmailModalVisible: false,
			twilioModal: false,
			addEventModal: false
		};
		this.toggleMenu = this.toggleMenu.bind(this);
		this.onMenuItemSelect = this.onMenuItemSelect.bind(this);
		this.onContactSelect = this.onContactSelect.bind(this);
		this.onEditSuccess = this.onEditSuccess.bind(this);
		this.onSmsSend = this.onSmsSend.bind(this);
	}

	componentDidUpdate() {
		const contactWithoutPhones = this.props.contact.map(c =>
			c.data.communication.phoneNumbers.getOrElse([]).length == 0
		).getOrElse(true);

		const contactWithoutEmails = this.props.contact.map(c =>
			c.data.communication.emails.getOrElse([]).length == 0
		).getOrElse(true);

		this.selectedContactMenu = [
			{id: "l1", label: "Change"},
			{id: "l2", label: "Create new"},
			{id: "l3", label: "Edit"},
			{id: "l4", label: "Send SMS", disabled: !this.props.contact.map(c => c.isOneOfPhoneNumbersMobile()).getOrElse(false)},
			{id: "l5", label: "Send e-mail", disabled: contactWithoutEmails},
			{id: "l6", label: "Copy"},
			{id: "l7", label: "Call", disabled: contactWithoutPhones},
			{id: "l8", label: "Add phone call event"}
		];
	}

	render() {
		const menuItems = this.props.job.isDefined ? this.selectedContactMenu : this.emptyContactMenu;
		return (
			<InfoModule icon={Icon.Phone} title={"CUSTOMER"} actionIcon={Icon.Overflow} onActionIconClick={this.toggleMenu}>
				{this.state.menuDropDownVisible &&
				<DropDownWrapper onOutsideClick={() => {this.setState({menuDropDownVisible: false})}}>
					<DropDownList items={menuItems}
								  itemToId={(link: DropDownItem) => link.id}
								  itemToLabel={(link: DropDownItem) => link.label}
								  itemDisabled={(link: DropDownItem) => link.disabled}
								  onSelect={this.onMenuItemSelect}/>
				</DropDownWrapper>}
				{this.state.searchBoxVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({searchBoxVisible: false})}>
					<SearchDropDown items={this.props.individualContacts}
									onChange={this.onContactSelect}
									itemToLabel={(contact: IndividualContact) => contact.data.displayName()}
									itemToId={(contact: IndividualContact) => contact.id}
									searchInputIcon={Icon.User}
									isLoading={!this.props.allContactsFetched}/>
				</DropDownWrapper>
				}
				{
					this.props.contact.map(c => {
						return (
							<span className="t-body" style={{whiteSpace: "pre-wrap", wordBreak: "break-word"}}>{c.data.fullDetails()}</span>
						)
					}).getOrElse(<span className="t-body">No customer selected</span>)
				}
				{this.state.newContactVisible &&
				<CreateContactModal onSuccessIndividual={this.onContactSelect}
									onClose={() => this.setState({newContactVisible: false})}/>
				}
				{this.state.editContactVisible && this.props.contact.isDefined &&
				<EditIndividualContactModal onSuccess={this.onEditSuccess}
											onClose={() => this.setState({editContactVisible: false})}
											contact={this.props.contact.get}/>
				}
				{this.state.sendSmsModalVisible &&
				<MessageModal onMessageSend={(value) => this.setState({sendSmsModalVisible: false},
					() => {this.onSmsSend(value)})}
							  onClose={() => this.setState({sendSmsModalVisible: false})}
							  title={`Send SMS to: ${this.props.contact.get.data.displayName()} (${this.props.contact.get.displayMobileNumbers()})`}/>}
				{this.state.sendEmailModalVisible &&
				<EmailMessageModal
					onMessageSend={(subject, message) => this.setState({sendEmailModalVisible: false},
						() => {this.onEmailSend(subject, message)})}
					onClose={() => this.setState({sendEmailModalVisible: false})}
					title={`Send e-mail to: ${this.props.contact.get.data.displayName()} (${this.props.contact.get.displayEmailAddresses()})`}/>}
				{this.state.twilioModal &&
				<TwilioModal onClose={() => this.setState({twilioModal: false})} contact={this.props.contact.get}/>
				}
				{this.state.addEventModal &&
				<AddEventModal onAdd={(em) => this.setState({addEventModal: false}, () => {this.onAddEvent(em)})}
							   onClose={() => this.setState({addEventModal: false})}/>}
			</InfoModule>
		);
	}

	onMenuItemSelect(item: DropDownItem) {
		this.setState({menuDropDownVisible: false, searchBoxVisible: false});
		switch (item.id) {
			case "l1":
				this.setState({searchBoxVisible: true, menuDropDownVisible: false});
				if (!this.props.allContactsFetched) {
					this.props.fetchContacts();
				}
				break;
			case "l2":
				this.setState({newContactVisible: true, menuDropDownVisible: false, searchBoxVisible: false});
				break;
			case "l3":
				this.setState({editContactVisible: true, menuDropDownVisible: false});
				break;
			case "l4":
				this.setState({sendSmsModalVisible: true, menuDropDownVisible: false});
				break;
			case "l5":
				this.setState({sendEmailModalVisible: true, menuDropDownVisible: false});
				break;
			case "l6":
				this.props.contact.map(c => TextUtils.copyToClipboard(c.data.fullDetails()));
				break;
			case "l7":
				this.setState({twilioModal: true, menuDropDownVisible: false});
				break;
			case "l8":
				this.setState({addEventModal: true, menuDropDownVisible: false});
				break;
		}
	}

	onContactSelect(contact: IndividualContact) {
		this.setState({searchBoxVisible: false, menuDropDownVisible: false, newContactVisible: false});
		this.props.job.map(l => {
			if (l.data.principalContactId === contact.id)
				return;
			const updatedJob = l.copy({data: l.data.copy({principalContactId: contact.id})});
			this.props.editJob(updatedJob);
		});
	}

	toggleMenu() {
		this.setState({menuDropDownVisible: !this.state.menuDropDownVisible, searchBoxVisible: false})
	}

	onEditSuccess() {
		this.setState({editContactVisible: false}, () => Toast.success("Job customer updated", "Job details update"))
	}

	onSmsSend(message: string) {
		this.props.job.map(l => this.props.sendSmsToJobContact(l.id, message));
	}

	onEmailSend(subject: string, message: string) {
		this.props.job.map(j => this.props.sendEmailToJobContact(j.id, subject, message));
	}

	onAddEvent(eventMessage: string) {
		this.props.job.map(j => this.props.addCallEvent(j.id, eventMessage))
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	return {
		contact: props.job.flatMap(l => getIndividualContact(l.data.principalContactId, state)),
		individualContacts: _.values(state.contact.individualContactMap),
		allContactsFetched: state.contact.allContactsFetched
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		editJob: (job: Job) => dispatch(
			editJob(
				job,
				() => Toast.success("Job customer updated", "Job details update"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Job details update"))
		),
		sendSmsToJobContact: (jobId: string, message: string) => dispatch(
			sendSmsToJobContact(
				jobId,
				message,
				() => Toast.success("SMS has been send.", "Send SMS to customer"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Send SMS to customer")
			)
		),
		sendEmailToJobContact: (jobId: string, subject: string, message: string) => dispatch(
			sendEmailToJobContact(
				jobId,
				subject,
				message,
				() => Toast.success("E-mail has been send.", "Send e-mail to customer"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Send e-mail to customer")
			)
		),
		addCallEvent: (jobId: string, message: string) => dispatch(
			addCallEvent(
				jobId,
				message,
				() => Toast.success("Phone event has been added.", "Add phone call event"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Add phone call event")
			)
		),
		fetchContacts: () => dispatch(fetchIndividualContacts(() => {},
			(err) => {notifyBugsnagAndShowToast(err, 'Fetch contacts')}))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(JobContact)